import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { Switch, TimePicker } from "antd";
import dayjs from "dayjs";
import { useFormattedShiftTypeOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import useTimeConverter from "core/Operations/useTimeConverter";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const ShiftPolicyForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { timeStringToFloat, floatToTimeString } = useTimeConverter();

  // const { data: shiftTypes } = useGetShiftTypesQuery({
  //   companyCode: watch("companyCode"),
  //   isTrue: true,
  // });

  // const shiftTypeOptions = Array.isArray(shiftTypes)
  //   ? shiftTypes
  //       //   .filter((d) => d.isActive)
  //       .map((o) => ({
  //         label: o.shiftTypeName,
  //         value: o.shiftTypeID.toString(),
  //       }))
  //   : [];

  const shiftTypeOption = useFormattedShiftTypeOption(watch("companyCode"));

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftName"
          type="text"
          placeholder="Shift Name"
          className={`form-control ${errors.shiftName ? "is-invalid" : ""}`}
          label="Shift Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Shift Name is required"
        />
      </div>
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftType"
          type="select"
          placeholder="Select Shift Type"
          className={`select ${errors.shiftType ? "is-invalid" : ""}`}
          label="Shift Type"
          labelClassName="form-label"
          optionData={shiftTypeOptions}
          required={true}
          requiredMessage="Shift Type is required"
          onChange={(e) => {
            setValue("shiftType", e.label);
            setValue("shiftTypeID", e.value);
          }}
          defaultValue={watch("shiftTypeID")}
        />
      </div> */}
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftStartTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Shift Start Time"
          className={`form-control ${
            errors.shiftStartTime ? "is-invalid" : ""
          }`}
          label="Shift Start Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Shift Start Time is required"
          onChange={(time, timeString) => {
            setValue("shiftStartTime", timeString);
            trigger("shiftStartTime");
          }}
          value={
            watch("shiftStartTime")
              ? dayjs(watch("shiftStartTime"), "HH:mm")
              : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftEndTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Shift End Time"
          className={`form-control ${errors.shiftEndTime ? "is-invalid" : ""}`}
          label="Shift End Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Shift End Time is required"
          onChange={(time, timeString) => {
            setValue("shiftEndTime", timeString);
            trigger("shiftEndTime");
          }}
          value={
            watch("shiftEndTime") ? dayjs(watch("shiftEndTime"), "HH:mm") : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="earliestClockIn"
          type="timePicker" format="HH:mm"
          placeholder="Earliest Clock In"
          className={`form-control ${
            errors.earliestClockIn ? "is-invalid" : ""
          }`}
          label="Earliest Clock In"
          labelClassName="form-label"
          required={true}
          requiredMessage="Earliest Clock In is required"
          
        />
      </div> */}
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftLoginGraceTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Shift Login Grace Time"
          className={`form-control ${
            errors.shiftLoginGraceTime ? "is-invalid" : ""
          }`}
          label="Shift Login Grace Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Shift Login Grace Time is required"
          onChange={(time, timeString) => {
            setValue("shiftLoginGraceTime", timeString);
            trigger("shiftLoginGraceTime");
          }}
          value={
            watch("shiftLoginGraceTime")
              ? dayjs(watch("shiftLoginGraceTime"), "HH:mm")
              : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shift1stHalfDayEndTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Shift 1st Half Day End Time"
          className={`form-control ${
            errors.shift1stHalfDayEndTime ? "is-invalid" : ""
          }`}
          label="Shift 1st Half Day End Time"
          labelClassName="form-label"
          required={false}
          requiredMessage="Shift 1st Half Day End Time is required"
          onChange={(time, timeString) => {
            setValue("shift1stHalfDayEndTime", timeString);
            trigger("shift1stHalfDayEndTime");
          }}
          value={
            watch("shift1stHalfDayEndTime")
              ? dayjs(watch("shift1stHalfDayEndTime"), "HH:mm")
              : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shift2ndHalfDayStartTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Shift 2nd Half Day Start Time"
          className={`form-control ${
            errors.shift2ndHalfDayStartTime ? "is-invalid" : ""
          }`}
          label="Shift 2nd Half Day Start Time"
          labelClassName="form-label"
          required={false}
          requiredMessage="Shift 2nd Half Day Start Time is required"
          onChange={(time, timeString) => {
            setValue("shift2ndHalfDayStartTime", timeString);
            trigger("shift2ndHalfDayStartTime");
          }}
          value={
            watch("shift2ndHalfDayStartTime")
              ? dayjs(watch("shift2ndHalfDayStartTime"), "HH:mm")
              : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <div className="">
          <label className="form-label" htmlFor="switch-md">
            &nbsp;Is Premium OT&nbsp;&nbsp;&nbsp;
          </label>
          <Switch
            checkedChildren="Yes"
            unCheckedChildren="No"
            checked={watch("isPremiumOT")}
            style={{
              caretColor: "#002299",
            }}
            // className="form-check-input"
            onChange={(e) => setValue("isPremiumOT", e)}
          />
        </div>
      </div>
      {watch("isPremiumOT") && (
        <>
          <div className="col-md-4 col-sg-12 mb-3">
            <Input
              name="otStartTime"
              type="timePicker"
              format="HH:mm"
              placeholder="OT Start Time"
              className={`form-control ${
                errors.otStartTime ? "is-invalid" : ""
              }`}
              label="OT Start Time"
              labelClassName="form-label"
              required={true}
              requiredMessage="OT Start Time is required"
              onChange={(time, timeString) => {
                console.log(timeString);
                console.log(time);
                setValue("otStartTime", timeString);
                trigger("otStartTime");
              }}
              value={
                watch("otStartTime")
                  ? dayjs(watch("otStartTime"), "HH:mm")
                  : null
              }
              // defaultValue={
              //   watch("otStartTime")
              //     ? dayjs(watch("otStartTime"), "HH:mm")
              //     : null
              // }
              variant="borderless"
              allowClear={false}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-md-4 col-sg-12 mb-3">
            <Input
              name="otEndTime"
              type="timePicker"
              format="HH:mm"
              placeholder="OT End Time"
              className={`form-control ${errors.otEndTime ? "is-invalid" : ""}`}
              label="OT End Time"
              labelClassName="form-label"
              required={true}
              requiredMessage="OT End Time is required"
              onChange={(time, timeString) => {
                setValue("otEndTime", timeString);
                trigger("otEndTime");
              }}
              value={
                watch("otEndTime") ? dayjs(watch("otEndTime"), "HH:mm") : null
              }
              variant="borderless"
              allowClear={false}
              style={{ width: "100%" }}
            />
          </div>
        </>
      )}

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="otMinimumHours"
          type="timePicker"
          format="HH:mm"
          placeholder="OT Minimum Hours"
          className={`form-control ${
            errors.otMinimumHours ? "is-invalid" : ""
          }`}
          label="OT Minimum Hours"
          labelClassName="form-label"
          required={true}
          requiredMessage="OT Minimum Hours is required"
          onChange={(time, timeString) => {
            setValue(
              "otMinimumHours",
              timeStringToFloat({ timeValue: timeString })
            );
            trigger("otMinimumHours");
          }}
          value={
            watch("otMinimumHours")
              ? dayjs(watch("otMinimumHours"), "HH:mm")
              : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div> */}
      <div className="col-md-4 col-sg-12 mb-3">
        <div className="form-floating">
          <TimePicker
            value={
              watch("otMinimumHours")
                ? dayjs(
                    floatToTimeString({ float: watch("otMinimumHours") }),
                    "HH:mm"
                  )
                : null
              // dayjs(
              //     floatToTimeString({ float: day.defaultValue }),
              //     "HH:mm"
              //   )
            }
            placeholder="OT Minimum Hours"
            className={`form-control working-hours-input mb-3`}
            onChange={(time, timeString) => {
              console.log(timeString);
              setValue(
                "otMinimumHours",
                timeStringToFloat({ timeValue: timeString })
              );
            }}
            format="HH:mm"
            variant="borderless"
            allowClear={true}
            //   style={{ width: "110px" }}
            getPopupContainer={(trigger) => trigger.parentNode}
            showNow={false}
          />
          <label className="form-label">OT Minimum Hours</label>
          {errors.otRoundOffMinimum && (
            <div className="invalid-feedback d-block">
              {errors.otRoundOffMinimum.message}
            </div>
          )}
        </div>
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <div className="form-floating">
          <TimePicker
            value={
              watch("otRoundOffMinimum")
                ? dayjs(
                    floatToTimeString({ float: watch("otRoundOffMinimum") }),
                    "HH:mm"
                  )
                : null
              // dayjs(
              //     floatToTimeString({ float: day.defaultValue }),
              //     "HH:mm"
              //   )
            }
            placeholder="OT Round Off Minimum"
            className={`form-control working-hours-input mb-3`}
            onChange={(time, timeString) => {
              console.log(timeString);
              setValue(
                "otRoundOffMinimum",
                timeStringToFloat({ timeValue: timeString })
              );
            }}
            format="HH:mm"
            variant="borderless"
            allowClear={true}
            //   style={{ width: "110px" }}
            getPopupContainer={(trigger) => trigger.parentNode}
            showNow={false}
          />
          <label className="form-label">OT Round Off Minimum</label>
          {errors.otRoundOffMinimum && (
            <div className="invalid-feedback d-block">
              {errors.otRoundOffMinimum.message}
            </div>
          )}
        </div>
      </div>
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="otRoundOffMinimum"
          type="timePicker"
          format="HH:mm"
          placeholder="OT Round Off Minimum"
          className={`form-control ${
            errors.otRoundOffMinimum ? "is-invalid" : ""
          }`}
          label="OT Round Off Minimum"
          labelClassName="form-label"
          required={true}
          requiredMessage="OT Round Off Minimum is required"
          onChange={(time, timeString) => {
            console.log("time string", timeString);
            console.log(timeStringToFloat({ timeValue: timeString }));
            setValue(
              "otRoundOffMinimum",
              timeStringToFloat({ timeValue: timeString })
            );
            trigger("otRoundOffMinimum");
          }}
          value={
            watch("otRoundOffMinimum")
              ? dayjs(watch("otRoundOffMinimum"), "HH:mm")
              : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div> */}

      <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
        <Input
          name="shiftTypeID"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.projectStatus ? "is-invalid" : ""
          }`}
          label="Shift Type"
          labelClassName="form-label"
          optionData={shiftTypeOption}
          required={false}
          requiredMessage="Shift Type is required"
          onChange={(selectedOption) => {
            setValue("shiftTypeID", selectedOption);
            trigger("shiftTypeID");
          }}
          defaultValue={watch("shiftTypeID")}
        />
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="currentDayRate"
          type="text"
          placeholder="Current Day Rate"
          className={`form-control ${
            errors.currentDayRate ? "is-invalid" : ""
          }`}
          label="Current Day Rate"
          labelClassName="form-label"
          required={true}
          requiredMessage="Current Day Rate is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="nextDayOTRate"
          type="text"
          placeholder="Next Day OT Rate"
          className={`form-control ${errors.nextDayOTRate ? "is-invalid" : ""}`}
          label="Next Day OT Rate"
          labelClassName="form-label"
          required={true}
          requiredMessage="Next Day OT Rate is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="latestClockIn"
          type="timePicker" format="HH:mm"
          placeholder="Latest Clock In"
          className={`form-control ${errors.latestClockIn ? "is-invalid" : ""}`}
          label="Latest Clock In"
          labelClassName="form-label"
          required={true}
          requiredMessage="Latest Clock In is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftAllowance"
          type="text"
          placeholder="Shift Allowance"
          className={`form-control ${
            errors.shiftAllowance ? "is-invalid" : ""
          }`}
          label="Shift Allowance"
          labelClassName="form-label"
          required={true}
          requiredMessage="Shift Allowance is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="additionalHour"
          type="text"
          placeholder="Additional Hour"
          className={`form-control ${
            errors.additionalHour ? "is-invalid" : ""
          }`}
          label="Additional Hour"
          labelClassName="form-label"
          required={true}
          requiredMessage="Additional Hour is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftGraceTime"
          type="text"
          placeholder="Shift Grace Time"
          className={`form-control ${
            errors.shiftGraceTime ? "is-invalid" : ""
          }`}
          label="Shift Grace Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Shift Grace Time is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="mealAllowance"
          type="text"
          placeholder="Meal Allowance"
          className={`form-control ${errors.mealAllowance ? "is-invalid" : ""}`}
          label="Meal Allowance"
          labelClassName="form-label"
          required={true}
          requiredMessage="Meal Allowance is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="breakHourOTRate"
          type="text"
          placeholder="Break Hour OT Rate"
          className={`form-control ${
            errors.breakHourOTRate ? "is-invalid" : ""
          }`}
          label="Break Hour OT Rate"
          labelClassName="form-label"
          required={true}
          requiredMessage="Break Hour OT Rate is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="earlyClockInOTRate"
          type="text"
          placeholder="Early Clock In OT Rate"
          className={`form-control ${
            errors.earlyClockInOTRate ? "is-invalid" : ""
          }`}
          label="Early Clock In OT Rate"
          labelClassName="form-label"
          required={true}
          requiredMessage="Early Clock In OT Rate is required"
          
        />
      </div> */}
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="select"
          placeholder="Select Status"
          className={`select ${errors.isActive ? "is-invalid" : ""}`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption ? selectedOption.value : null);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div> */}
    </div>
  );
};

export default ShiftPolicyForm;
